import { Button, ButtonSizesEnum, ButtonThemesEnum } from '@propertyfinder/button';
import { FunctionComponent, h } from 'preact';

import { SaveSearchEmptyStatePropsInterface } from 'common/module/save-search/empty-state/props.interface';

export const SaveSearchEmptyStateTemplate: FunctionComponent<SaveSearchEmptyStatePropsInterface> = ({
  icon,
  title,
  description,
  buttonText,
  onClick,
  children,
}) => (
  <div className='save-search__empty-state__container'>
    <div className='save-search__empty-state__icon-container'>{icon}</div>
    <span className='save-search__empty-state__title'>{title}</span>
    <span className='save-search__empty-state__description'>{description}</span>
    <Button onClick={onClick} theme={ButtonThemesEnum.SECONDARY} size={ButtonSizesEnum.SMALL}>
      {buttonText}
    </Button>
    {children}
  </div>
);
